import axiosConfig from '../../../redux/UserManagement/axiosConfig';

export interface RolePermissions {
  app_level_role_id: number;
  group_name: string;
  display_name: string;
  permissions: any;
  is_active: boolean;
}
export interface RolePermissions1 {
  app_level_role_id: number;
  group_name: string;
  display_name: string;
  permissions: any;
  is_active: boolean;
}


export interface UserAccessData {
  rolePermissions: RolePermissions;
  updatedBy: string;
  updatedAt: string;
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
  error?: string;
}

class UserAccessApiService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = process.env.REACT_APP_API_BASE_URL || '/api';
  }

  /**
   * Get user access permissions from the database
   */
  async getUserAccess(): Promise<ApiResponse<RolePermissions[]>> {
    try {
      // For development/testing, you can use a mock response


      // Real API call
      if (process.env.REACT_APP_ENV === 'development') {
        const ROLE_PERMISSIONS: any[] = [
          {
            "app_level_role_id": 1,
            "group_name": "super_admin",
            "display_name": "Super Admin",
            "permissions": {
              super_admin: [
                {
                  id: 'manage_admins', name: 'Manage Administrators',
                  value: true
                },
                {
                  id: 'system_backup', name: 'System Backup & Restore',
                  value: true
                },
                {
                  id: 'create_projects', name: 'Create Projects',
                  value: true
                },
                {
                  id: 'delete_projects', name: 'Delete Projects',
                  value: true
                },
                {
                  id: 'manage_devices', name: 'Manage Devices',
                  value: true
                },
                {
                  id: 'view_analytics', name: 'View Analytics',
                  value: true
                },
                {
                  id: 'view_pipe_inventory', name: 'View Pipe Inventory',
                  value: true
                },
                {
                  id: 'edit_pipe_inventory', name: 'Add / Edit Pipe Inventory',
                  value: true
                },
                {
                  id: 'delete_pipe_inventory', name: 'Delete Pipe Inventory',
                  value: true
                },
                {
                  id: 'manage_users', name: 'Manage Users',
                  value: true
                },
                {
                  id: 'manage_system', name: 'Manage System Settings',
                  value: true
                },
                {
                  id: 'manage_security', name: 'Manage Security Settings',
                  value: true
                },
                {
                  id: 'view_audit_logs', name: 'View Audit Logs',
                  value: true
                },
                {
                  id: 'edit_projects', name: 'Edit Projects',
                  value: true
                },
                {
                  id: 'view_projects', name: 'View All Projects',
                  value: true
                },
                {
                  id: 'view_devices', name: 'View Devices',
                  value: true
                },
                {
                  id: 'export_analytics', name: 'Export Analytics',
                  value: true
                },
                {
                  id: 'assign_roles', name: 'Assign Roles',
                  value: true
                }
              ],
              update_date: "2025-08-29T10:00:00.000Z",
              created_date: "2025-08-29T10:00:00.000Z"
            },
            "is_active": true
          },
          {
            "app_level_role_id": 2,
            "group_name": "admin",
            "display_name": "Admin",
            "permissions": {
              admin: [
                {
                  id: 'create_projects', name: 'Create Projects',
                  value: true
                },
                {
                  id: 'edit_projects', name: 'Edit Projects',
                  value: true
                },
                {
                  id: 'view_projects', name: 'View All Projects',
                  value: true
                },
                {
                  id: 'manage_devices', name: 'Manage Devices',
                  value: true
                },
                {
                  id: 'view_devices', name: 'View Devices',
                  value: true
                },
                {
                  id: 'view_analytics', name: 'View Analytics',
                  value: true
                },
                {
                  id: 'view_pipe_inventory', name: 'View Pipe Inventory',
                  value: true
                },
                {
                  id: 'edit_pipe_inventory', name: 'Add / Edit Pipe Inventory',
                  value: true
                },
                {
                  id: 'delete_pipe_inventory', name: 'Delete Pipe Inventory',
                  value: true
                },
                {
                  id: 'export_analytics', name: 'Export Analytics',
                  value: true
                },
                {
                  id: 'manage_users', name: 'Manage Users',
                  value: true
                },
                {
                  id: 'assign_roles', name: 'Assign Roles',
                  value: true
                }
              ],
              update_date: "2025-08-29T10:00:00.000Z",
              created_date: "2025-08-29T10:00:00.000Z"
            },
            "is_active": true
          },
          {
            "app_level_role_id": 3,
            "group_name": "manager",
            "display_name": "manager",
            "permissions": {

              manager: [
                {
                  id: 'create_projects', name: 'Create Projects',
                  value: true
                },
                {
                  id: 'edit_projects', name: 'Edit Projects',
                  value: true
                },
                {
                  id: 'view_projects', name: 'View All Projects',
                  value: true
                },
                {
                  id: 'view_devices', name: 'View Devices',
                  value: true
                },
                {
                  id: 'view_analytics', name: 'View Analytics',
                  value: true
                },
                {
                  id: 'export_analytics', name: 'Export Analytics',
                  value: true
                }
              ],
              update_date: "2025-08-29T10:00:00.000Z",
              created_date: "2025-08-29T10:00:00.000Z"
            },
            "is_active": true
          },
          {
            "app_level_role_id": 3,
            "group_name": "user",
            "display_name": "user",
            "permissions": {

              user: [
                {
                  id: 'view_projects', name: 'View All Projects',
                  value: true
                },
                {
                  id: 'view_devices', name: 'View Devices',
                  value: true
                },
                {
                  id: 'view_analytics', name: 'View Analytics',
                  value: true
                }
              ],
              update_date: "2025-08-29T10:00:00.000Z",
              created_date: "2025-08-29T10:00:00.000Z"
            },
            "is_active": true
          },
          {
            "app_level_role_id": 4,
            "group_name": "viewer",
            "display_name": "Viewer",
            "permissions": {
              viewer: [
                {
                  id: 'view_projects', name: 'View All Projects',
                  value: true
                },
                {
                  id: 'view_analytics', name: 'View Analytics',
                  value: true
                }
              ],
              update_date: "2025-08-29T10:00:00.000Z",
              created_date: "2025-08-29T10:00:00.000Z"
            },
            "is_active": true
          }

        ]
        return {
          success: true,
          data: ROLE_PERMISSIONS || [],
          message: 'Permissions loaded successfully'
        };
      }
      const url = '/role/getAllAppLevelRoles';
      const response = await axiosConfig.get(url);
      if (response.status === 200) {

        return {
          success: true,
          data: response.data.data || [],
          message: 'Permissions loaded successfully'
        };
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      return {
        success: false,
        data: [],
        error: error instanceof Error ? error.message : 'Unknown error'
      };
    }
  }

  /**
   * Save user access permissions to the database
   */
  async saveUserAccess(rolePermissions: RolePermissions[], updatedBy: string): Promise<ApiResponse<any>> {
    try {

      const url = '/role/bulkCreateUpdateAppLevelRole';
      // Real API call
      const response = await axiosConfig.post(url, rolePermissions);

      if (response.status === 200) {
        return {
          success: true,
          data: response.data,
          message: 'Permissions saved successfully'
        };
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      return {
        success: false,
        data: null,
        error: error instanceof Error ? error.message : 'Unknown error'
      };
    }
  }

  /**
   * Restore user access permissions from the database
   */
  async restoreUserAccess(): Promise<ApiResponse<RolePermissions | null>> {
    try {
      // For development/testing, you can use a mock response


      // Real API call
      const response = await axiosConfig.get('/user/permissions/access/restore');

      if (response.status === 200) {
        return {
          success: true,
          data: response.data.data || {},
          message: 'Permissions restored successfully'
        };
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      return {
        success: false,
        data: null,
        error: error instanceof Error ? error.message : 'Unknown error'
      };
    }
  }

  async getUserAccessPermissions(payload: any) {
    try {
      // For development/testing, you can use a mock response

      const url = `/user/getUserByCognitoId/${payload.cognitoId}`;
      const response = await axiosConfig.get(url);

      if (response.status === 200) {
        const userData = response.data.data;
//         const userExtraDetails = userData?.user_extra_details;
//         const userRole = userData?.appLevelRole?.group_name || userData?.role;

//         // Only merge permissions for user, viewer, and manager roles
//         const shouldMergeExtraDetails = userExtraDetails &&
//           (userRole === 'user' || userRole === 'viewer' || userRole === 'manager');

//         // Create a deep copy of the entire userData to avoid mutating the original
//         let trasnportedData = JSON.parse(JSON.stringify(userData));

//         if (shouldMergeExtraDetails && trasnportedData?.appLevelRole?.permissions?.user) {
//           // Get the existing user permissions array from appLevelRole.permissions.user
//           const existingUserPermissions = Array.isArray(trasnportedData.appLevelRole.permissions.user) 
//             ? [...trasnportedData.appLevelRole.permissions.user] 
//             : [];
          
//           // Create a Set of existing permission IDs to check for duplicates
//           const existingPermissionIds = new Set<string>(
//             existingUserPermissions.map((p: any) => typeof p === 'string' ? p : p.id)
//           );

//           // Permission name mapping
//           const permissionNameMap: Record<string, string> = {
//             'create_projects': 'Create Projects',
//             'edit_projects': 'Edit Projects',
//             'delete_projects': 'Delete Projects',
//             'export_analytics': 'Export Analytics',
//             'view_map': 'View Map',
//             'view_devices': 'View Devices',
//             'manage_devices': 'Manage Devices'
//           };

//           // Helper function to add permission if not already exists
//           const addPermissionIfNotExists = (permissionId: string) => {
//             if (!existingPermissionIds.has(permissionId)) {
//               existingUserPermissions.push({
//                 id: permissionId,
//                 name: permissionNameMap[permissionId] || permissionId.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase()),
//                 value: true
//               });
//               existingPermissionIds.add(permissionId);
//             }
//           };

//           // Process project permissions
//           if (userExtraDetails.project && Array.isArray(userExtraDetails.project)) {
//             userExtraDetails.project.forEach((permissionId: string) => {
//               addPermissionIfNotExists(permissionId);
//             });
//           }

//           // Process analysis permissions
//           if (userExtraDetails.analysis && Array.isArray(userExtraDetails.analysis)) {
//             userExtraDetails.analysis.forEach((permissionId: string) => {
//               addPermissionIfNotExists(permissionId);
//             });
//           }

//           // Process map permissions
//           if (userExtraDetails.map && Array.isArray(userExtraDetails.map)) {
//             userExtraDetails.map.forEach((permissionId: string) => {
//               addPermissionIfNotExists(permissionId);
//             });
//           }

//           // Process devices permissions
//           if (userExtraDetails.devices && Array.isArray(userExtraDetails.devices)) {
//             userExtraDetails.devices.forEach((permissionId: string) => {
//               addPermissionIfNotExists(permissionId);
//             });
//           }

//           console.log('existingUserPermissions', existingUserPermissions);
//           // Update appLevelRole.permissions.user with the merged permissions array
//           trasnportedData.appLevelRole = {
//             ...trasnportedData.appLevelRole,
//             permissions: {
//               ...trasnportedData.appLevelRole.permissions,
//               user: existingUserPermissions
//             }
//           };
//         }
// console.log('trasnportedData', trasnportedData);
//         // Add userExtraDetails to the transported data
//         trasnportedData.userExtraDetails = userExtraDetails;

        return {
          success: true,
          data: userData || [],
          message: 'Permissions loaded successfully'
        };
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      return {
        success: false,
        data: [],
        error: error instanceof Error ? error.message : 'Unknown error'
      };
    }
  }

}

export const userAccessApi = new UserAccessApiService();
export default userAccessApi;
